import { CSSProperties } from 'react'
import styled from 'styled-components'
import { TabMenuItem } from './index'

export interface TabItemType {
  title: string
  id: string
}

export default function NormalTabs(props: {
  menus: TabItemType[]
  selected: TabItemType['id']
  onChange: (id: TabItemType['id']) => void
  className?: string
  style?: CSSProperties
}) {
  return (
    <TabMenuWrapper className={props.className} style={props.style}>
      {props.menus.map((menu) => (
        <StyledTabMenuItem
          className={'tabMenuItem'}
          key={menu.id}
          onClick={() => props.onChange(menu.id)}
          selected={menu.id === props.selected}
          title={menu.title}
        />
      ))}
    </TabMenuWrapper>
  )
}

const StyledTabMenuItem = styled(TabMenuItem)`
  &:hover {
    span {
      color: #ffffff;
    }
  }
  span {
    color: ${({ selected }) => (selected ? '#FFF' : '#3D81D9')};
    font-weight: ${({ selected }) => (selected ? 'bold' : 'normal')};
  }
`

const TabMenuWrapper = styled.div`
  height: 57px;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 48px;
  /* border-bottom: 2px solid #1453a4; */
  padding-top: 26px;
  /* &::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 2px;
    border-radius: 1px;
    background: #135dbd;
    left: 0;
    bottom: 7px;
  } */
`
